const STORAGE_KEY = "auth_tokens_v1";

// "Safer" than localStorage for XSS persistence (still not perfect; best is httpOnly cookies).
const storage = window.localStorage;

export function getTokens() {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setTokens({ accessToken, refreshToken }) {
  storage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      accessToken,
      refreshToken,
    })
  );
}

export function clearTokens() {
  storage.removeItem(STORAGE_KEY);
}

export function getAccessToken() {
  return getTokens()?.accessToken || null;
}

export function getRefreshToken() {
  return getTokens()?.refreshToken || null;
}


